import Event from '../Event';
import { ExtraFeature } from '../../admin/State';

export default class FeaturesRequested extends Event {
    public static type = 'FeaturesRequested';

    constructor(public readonly features: ExtraFeature[]) {
        super(FeaturesRequested.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/core/events/FeaturesRequested.ts